import ExoAvatar from "../../../components/exo/ExoAvatar";

const DisplayAvatar = ({ label, value }) => {
  return <ExoAvatar picture={value} name={label} />;
};

export default DisplayAvatar;
